import React from 'react';
import styles from './index.module.scss';

const YoungAgeScreen = ({ backButtonClick }) => {
  return (
    <div
      className={styles.container}
      style={{ backgroundImage: 'url("/images/26ua-lm-lfc-auth/bg.png")' }}
    >
      <p className={styles.title}>
        На жаль, <br></br>вік не підтверджено:(
      </p>
      <p className={styles.description}>
        Повернися на попередній крок і спробуй<br></br> пройти перевірку віку
        знову!
      </p>
      <button className={styles.backButton} onClick={backButtonClick}>
        <img
          className={styles.buttonGlow}
          src="/images/26ua-lm-lfc-auth/button-glow.svg"
          alt=""
        />
        <span>Назад</span>
      </button>
    </div>
  );
};

export default YoungAgeScreen;
